import { render, staticRenderFns } from "./PaymentOnboardingRelay.vue?vue&type=template&id=d9ae1598&scoped=true"
import script from "./PaymentOnboardingRelay.vue?vue&type=script&lang=js"
export * from "./PaymentOnboardingRelay.vue?vue&type=script&lang=js"
import style0 from "./PaymentOnboardingRelay.vue?vue&type=style&index=0&id=d9ae1598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ae1598",
  null
  
)

export default component.exports